import React, { useState } from "react";
import { TabButton } from "../../common/APICommon";

import { CreditNotesPayable } from "./CreditNotesPayable"
import { Expenses } from "./Expenses"
import { GoodReceipt } from "./GoodReceipt"
import { Bills } from "./Bills"
import { Payments } from "./Payments"
import { PurchaseOrder } from "./PurchaseOrder"
import Journals from "../Accounts/Journals"
import NoAccess from "../NoAccess";
// MUI Icons
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { PurchaseReturn } from "./PurchaseReturn";

export default function Payables() {








// #region Tabs
  const [activeTab, setActiveTab] = useState("PurchaseOrders")

  const tabs = [
    {
      label:"Purchase Orders",
      isActive: activeTab === "PurchaseOrders",
      onClick: () => setActiveTab("PurchaseOrders")
    },
    {
      label:"Goods Receipt",
      isActive: activeTab === "GR",
      onClick: () => setActiveTab("GR")
    },
    {
      label:"Purchase Return",
      isActive: activeTab === "PurchaseReturn",
      onClick: () => setActiveTab("PurchaseReturn")
    },
    {
      label:"Purchase Invoice",
      isActive: activeTab === "Bills",
      onClick: () => setActiveTab("Bills")
    },
    {
      label:"Credit Notes",
      isActive: activeTab === "CreditNotes",
      onClick: () => setActiveTab("CreditNotes")
    },
    {
      label:"Payments",
      isActive: activeTab === "Payments",
      onClick: () => setActiveTab("Payments")
    },
    {
      label:"Expenses",
      isActive: activeTab === "Expenses",
      onClick: () => setActiveTab("Expenses")
    },
    {
      label:"AP Transactions",
      isActive: activeTab === "APTransactions",
      onClick: () => setActiveTab("APTransactions")
    },
  ]
//#endregion










//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPayables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <ReceiptLongIcon fontSize="large" className="text-theme-color" />
              Payables
            </h2>
            <p className="text-gray-500 mt-1">Credit purchases and vendor payables.</p>
          </div>
        </div>

        {tabs.map((tab, index) => {
          return (
            <TabButton
              key={index}
              label={tab.label}
              isActive={tab.isActive}
              onClick={tab.onClick}
            />
          )
        })}

        {activeTab === "CreditNotes" &&
          <CreditNotesPayable active={activeTab === "CreditNotes"}/>
        }
        {activeTab === "Expenses" &&
          <Expenses active={activeTab === "Expenses"}/>
        }
        {activeTab === "GR" &&
          <GoodReceipt active={activeTab === "GR"}/>
        }
        {activeTab === "PurchaseReturn" &&
          <PurchaseReturn active={activeTab === "PurchaseReturn"}/>
        }
        {activeTab === "Bills" &&
          <Bills active={activeTab === "Bills"}/>
        }
        {activeTab === "Payments" &&
          <Payments active={activeTab === "Payments"}/>
        }
        {activeTab === "PurchaseOrders" &&
          <PurchaseOrder active={activeTab === "PurchaseOrders"}/>
        }
        {activeTab === "APTransactions" &&
          <Journals type={"AP"}/>
        }
      </div>
    </>
  );
}







